"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateProperty = class CreateProperty extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.$fn.schemaDefaults('CreateProperty', { owner: null });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_property'),
            object: 'list',
            data: []
        };
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    propertyUnitTypes;
    async $$load_propertyUnitTypes() {
        return this.$fn.fetch('list_property_types').then(p => _.orderBy(p, ['name']));
    }
    units;
    resourceTitle;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['resource', 'editor', 'container', 'formName', 'formId', 'propertyUnitTypes', 'units', 'resourceTitle', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                container: null,
                formName: "meter",
                formId: null,
                propertyUnitTypes: null,
                units: ["ha",
                    "m2",
                ],
                resourceTitle: this.$fn.pgettext("Property", "Property"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Property", "New property"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4194_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_4200_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_4202_getActionArgs($event) {
        return {
            location: {
                name: "app.property",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_4204_getActionArgs($event) {
        return {
            grid: "properties",
        };
    }
    async act_1040167445267876_rest_4198_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4194 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4194_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4193 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4194,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4193],
        });
        const act_2248226175642056_closeComponent_4196 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4195 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4196,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4195],
        });
        const act_1040167445267876_closeComponent_4200 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_4200_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4199 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_4200,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_4202 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_4202_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4201 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_4202,
            event: "saved",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_4204 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_4204_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4203 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_4204,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_rest_4198 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_4198_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_saved_4199, evh_1040167445267876_saved_4201, evh_1040167445267876_saved_4203],
        });
        const evh_1040167445267876_submit_4197 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_4198,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4197],
        });
        const act_1419464017721962_closeComponent_4206 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4205 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_4206,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4205],
        });
        return {
            act_7315092382398562_closeModal_4194,
            evh_7315092382398562_close_4193,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4196,
            evh_2248226175642056_close_4195,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_4200,
            evh_1040167445267876_saved_4199,
            act_1040167445267876_navigate_4202,
            evh_1040167445267876_saved_4201,
            act_1040167445267876_reloadSlickgrid_4204,
            evh_1040167445267876_saved_4203,
            act_1040167445267876_rest_4198,
            evh_1040167445267876_submit_4197,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_4206,
            evh_1419464017721962_clickPreventStop_4205,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_rest_4198,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateProperty.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateProperty.prototype, "onSize", null);
CreateProperty = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateProperty);
exports.default = CreateProperty;
vue_property_decorator_1.Vue.component("CreateProperty", CreateProperty);
